window.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('input[name="option"]').forEach(el => {
        el.checked = false;

        el.addEventListener('click', () => {
            document.getElementById('wizard-init').style.opacity = '1';
            document.getElementById('wizard-init').style.cursor = 'pointer';
        })
    })


    document.getElementById('wizard-init').addEventListener('click', function (event) {
        event.preventDefault();
        const selected = document.querySelector('input[name="option"]:checked');
        if (selected) {
            document.getElementById('wizard-section-heading').textContent = selected.dataset.heading;
            document.getElementById('wizard-section-desc').querySelector('p').innerHTML = selected.dataset.desc;
            if (selected.value === 'bussines') {
                document.getElementById('init_questions').style.display = 'none';
                document.getElementById('bussines_answer').style.display = 'flex';
            } else {
                document.getElementById('init_questions').style.display = 'none';
                document.getElementById('personal_answer').style.display = 'flex';
            }
        } else {
            console.log('none')
        }
    });

    document.querySelectorAll('#wizard_back').forEach(el => {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            const init = document.getElementById('init_questions');
            document.getElementById('wizard-section-heading').textContent = init.dataset.heading;
            document.getElementById('wizard-section-desc').querySelector('p').textContent = init.dataset.heading;
            document.getElementById('init_questions').style.display = 'flex';
            document.getElementById('bussines_answer').style.display = 'none';
            document.getElementById('personal_answer').style.display = 'none';
        });
    });

});
